import React from "react";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/material";
import "./Header.css";
import ImageBox from "./ImageBox";
import homeimg from "./images/newfooter.png";
import { getESTYear } from "./Utils";
function Footer() {
  const [load, setLoad]= React.useState(false);
  const [year] = React.useState(getESTYear());
  React.useEffect(()=>{
    const timeout = setTimeout(()=>{
        setLoad(true);
      },1000)
      return () =>{
        clearTimeout(timeout);
      }
  })
  return (
    <>
    {load?  
    <Box
      sx={{
        backgroundColor: "#002d82",
        width: "100%",
        height: "fit-content",
        padding: "0 !important",
        color: "white",
        fontSize: "11px",
        textAlign: "center",
        minWidth:"max-content"
      }}
    >
      <Grid container id="wrap">
        <span>
          <ImageBox myclass="footerclass" imageUrl={homeimg}></ImageBox>
        </span>
        <div style={{minHeight:"100%", position:"relative"}}>
        <div id="content">
          <div style={{marginTop:"-4px", marginBottom:"8px"}}>
          <br></br>
          <br></br>
          {/*Webster Bank, N.A. Webster, Webster Bank, <br></br>
          the Webster Bank logo and the W symbol are trademarks of Webster Financial Corporation<br></br>
          and registered in the U.S. Patent and Trademark Office.<br></br>
          &copy; {year} Webster Financial Corporation. All rights reserved.<br></br>*/}
          {/*<a className="footer-link-first" target="_blank" rel="noopener noreferrer" href="https://www.websterbank.com/security/">Security</a> <span className="vl"></span>
          <a className="footer-link" href="https://www.websterbank.com/legal/">Legal</a> <span className="vl"></span>
          <a className="footer-link" href="https://www.websterbank.com/privacy/">Privacy</a> <span className="vl"></span> 
          <a className="footer-link" href="https://www.websterbank.com/security/protect-yourself/disclosure-fees/">Disclosures and Fees</a> <span className="vl"></span> 
          <a className="footer-link" href="https://www.websterbank.com/accessibility-statement/">Accessibility Statement</a> <span className="vl"></span> 
          <a className="footer-link" href="https://www.websterbank.com/about/accessibility/">Accessible Banking</a> <span className="vl"></span> 
          <a className="footer-link" href="https://www.websterbank.com/site-map/">Sitemap</a> <br></br>
          <br></br>*/}
          
          Webster Bank, a division of Santander Bank, N.A. <br></br>
          Member FDIC Equal Housing Lender. Webster, Webster Bank, Webster Investments, the Webster Bank logo, <br></br>
          and the W symbol are trademarks of Santander Holdings USA, Inc. <br></br>
          and registered in the U.S. Patent and Trademark Office. <br></br>
          &copy; {year} Santander Holdings USA, Inc. All Rights Reserved. <br></br>

          {/* Webster Bank, N.A. <br></br>
          Webster, Webster Bank, Webster Investments, the Webster Bank logo <br></br>
          and the W symbol are trademarks of Webster Financial Corporation <br></br>
          and registered in the U.S. Patent and Trademark Office. <br></br>
          &copy; {year} Webster Financial Corporation. All rights reserved. <br></br> */}
          </div>
        </div>
        </div>
      </Grid>
    </Box>
    : null}
    </>
  );
}

export default Footer;